import type { CSSProperties } from 'react';
import wordmarkDark from '@/assets/brand/cajita-wordmark-dark.png';
import wordmarkLight from '@/assets/brand/cajita-wordmark-light.png';
import icon from '@/assets/brand/cajita-icon.png';

/**
 * Logos de Cajita.
 *  - wordmark-dark:  texto oscuro, para fondos claros (login, registro, bienvenida).
 *  - wordmark-light: texto blanco, para fondos oscuros (sidebar).
 *  - icon:           cuadrado redondeado navy con la "G" (topbar mobile).
 * `height` en px; el ancho sale de la proporcion del archivo.
 */
const LOGOS = {
  'wordmark-dark': { src: wordmarkDark, ratio: 598 / 253 },
  'wordmark-light': { src: wordmarkLight, ratio: 598 / 253 },
  icon: { src: icon, ratio: 1 },
} as const;

export type BrandLogoVariant = keyof typeof LOGOS;

interface BrandLogoProps {
  variant: BrandLogoVariant;
  height: number;
  className?: string;
  style?: CSSProperties;
}

export function BrandLogo({ variant, height, className, style }: BrandLogoProps): JSX.Element {
  const { src, ratio } = LOGOS[variant];
  return (
    <img
      src={src}
      alt="Cajita"
      width={Math.round(height * ratio)}
      height={height}
      draggable={false}
      className={className}
      style={{ display: 'block', flex: 'none', ...style }}
    />
  );
}
